var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddActivity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#8F1B77"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1429 10.5342C17.1429 10.0814 16.7592 9.71436 16.2858 9.71436C15.8124 9.71436 15.4286 10.0814 15.4286 10.5342V15.1802H10.5715C10.0981 15.1802 9.71436 15.5473 9.71436 16.0001C9.71436 16.4529 10.0981 16.8199 10.5715 16.8199H15.4286V21.4659C15.4286 21.9187 15.8124 22.2858 16.2858 22.2858C16.7592 22.2858 17.1429 21.9187 17.1429 21.4659V16.8199H22.0001C22.4735 16.8199 22.8572 16.4529 22.8572 16.0001C22.8572 15.5473 22.4735 15.1802 22.0001 15.1802H17.1429V10.5342Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddActivity);
export default __webpack_public_path__ + "static/media/add-activity.cc8b81951ed96c06ecd9316b991d898a.svg";
export { ForwardRef as ReactComponent };